import Component from '@glimmer/component';
export default class TpkSelectContainerOptionsOption extends Component {
  get id() {
    return `${this.args.guid}-listbox-option-${this.args.index}`;
  }
  get isSelected() {
    if (this.args.multiple === true) {
      return this.args.selected.includes(this.args.option);
    }
    return this.args.selected === this.args.option;
  }
  get hasVirtualFocus() {
    return this.args.activeChild?.id === this.id;
  }
}